import { startUp } from "./start";

const bootstrap = () =>
  startUp({
    isDebug: true,
    configureServices() {}
  });

export default bootstrap;
